export const state = () => ({
  basePath: null,
  carInsuranceUnderMaintenance: false,
  comparison: null,
  coverType: null,
  current: null,
  list: [],
  meta: null,
  validations: []
});

export const mutations = {
  add (state, product) {
    state.list.filter(p => product.id === p.id).forEach(p => this.commit('products/remove', p.id));
    state.list = [...state.list, product];
  },
  clear (state) {
    state.coverType = null;
    state.current = null;
    state.list = [];
  },
  remove (state, id) {
    state.list = state.list.filter(p => p.id !== id);
  },
  set (state, product) {
    state.current = product;
  },
  setBasePath (state, basePath) {
    state.basePath = basePath;
  },
  setCarAndHomeInsuranceUnderMaintenance (state, underMaintenance) {
    state.carInsuranceUnderMaintenance = underMaintenance;
  },
  setComparison (state, comparison) {
    state.comparison = comparison;
  },
  setCoverType (state, cover) {
    state.coverType = cover;
  },
  setList (state, list) {
    state.list = list;
  },
  setMeta (state, meta) {
    state.meta = meta;
  },
  setValidations (state, validations) {
    state.validations = validations;
  }
};

export const getters = {
  get (state) {
    return state.current;
  },
  getBasePath (state) {
    return state.basePath;
  },
  getCarAndHomeInsuranceUnderMaintenance (state) {
    return state.carInsuranceUnderMaintenance;
  },
  getComparison (state) {
    return state.comparison;
  },
  getCoverType (state) {
    return state.coverType;
  },
  getList (state) {
    return state.list;
  },
  getMeta (state) {
    return state.meta;
  },
  getValidations (state) {
    return state.validations;
  }
};
